import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconTrending4"><Path d="M2.75 4.75V16.25C2.75 17.9069 4.09315 19.25 5.75 19.25H21.25M6.75 15.25L10 12C10.5523 11.4477 11.4477 11.4477 12 12V12C12.5523 12.5523 13.4477 12.5523 14 12L18.7539 7.24608M14.75 6.75H19.25V11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconTrending4;
